import type { ReactNode } from "react";
import { assets } from "../../assets/assets";

/** The sign-in page layout (logo + form on the left, banner on the right), shared by every auth screen. */
export default function AuthShell({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col md:flex-row font-geist w-screen bg-white">
      <section className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="flex flex-col gap-6">
            <div className="flex justify-start">
              <img src={assets.MainLogo} alt="Logo" className="h-16 w-auto object-contain" />
            </div>
            <h1 className="text-4xl md:text-5xl font-semibold leading-tight text-gray-900">
              <span className="font-light tracking-tighter">{title}</span>
            </h1>
            {subtitle && <p className="text-gray-600 text-xs">{subtitle}</p>}
            {children}
          </div>
        </div>
      </section>

      <section className="hidden md:block flex-1 relative p-4">
        <div className="absolute inset-4 rounded-3xl bg-cover bg-center shadow-2xl" style={{ backgroundImage: `url(${assets.LoginBanner})` }}></div>
      </section>
    </div>
  );
}

export const GlassInputWrapper = ({ children }: { children: ReactNode }) => (
  <div className="rounded-2xl border border-gray-200 bg-white transition-colors focus-within:border-[#ff6d27] focus-within:bg-white">
    {children}
  </div>
);

export const authInput = "w-full bg-transparent text-xs p-4 rounded-2xl focus:outline-none text-gray-900";
export const authButton = "w-full rounded-2xl bg-[#ff6d27] py-4 font-medium text-white hover:bg-[#E85A1B] transition-colors text-xs disabled:opacity-50";
